import { supabase } from '@/lib/supabase'
import type { TF } from '../types'

export type OhlcvRow = {
  open_time: string
  open: number
  high: number
  low: number
  close: number
  volume?: number | null
}

export async function fetchCandles(params: { symbol: string; timeframe: TF; limit?: number }): Promise<OhlcvRow[]> {
  const symbol = String(params.symbol || '').trim().toUpperCase()
  const timeframe = String(params.timeframe || '').trim().toUpperCase() as TF
  const limit = Math.max(1, Number(params.limit || 500))

  if (!symbol) return []

  // Para TFs altos, utiliza RPC (evita qualquer cache intermediário e padroniza derivação)
  if (['240','720','D','W','M'].includes(timeframe)) {
    const { data, error } = await supabase
      .rpc('fetch_ohlcv', { p_symbol: symbol, p_tf: timeframe, p_limit: limit })
    if (error) throw new Error(error.message || 'Falha ao carregar candles')
    const rows = Array.isArray(data) ? (data as any[]).map((r) => ({
      open_time: String((r as any).open_time),
      open: Number((r as any).open),
      high: Number((r as any).high),
      low: Number((r as any).low),
      close: Number((r as any).close),
      volume: (r as any).volume == null ? null : Number((r as any).volume),
    })) : []
    // RPC já retorna ordenado ascendente
    return rows
  }

  // TFs intraday padrão via table API
  const { data, error } = await supabase
    .from('ohlcv_candles')
    .select('open_time, open, high, low, close, volume')
    .eq('symbol', symbol)
    .eq('timeframe', timeframe)
    .order('open_time', { ascending: false })
    .limit(limit)

  if (error) throw new Error(error.message || 'Falha ao carregar candles')

  const rows = (data || []) as OhlcvRow[]
  return rows.reverse()
}
